// extracted by mini-css-extract-plugin
export default {"beverageChip":"beverageChip--rOFcK","searchTextField":"searchTextField--CcLh6"};